/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InquiryContactResource { 
    id: number;
    date: string;
    client: string;
    note: string;
    source: string;
    way: string;
    count: number;
    delay: boolean;
    settleBy: string;
    state: string;
    stateText: string;
}

